










import { Component, Vue, Prop } from "vue-property-decorator";
import Tabs from "./Tabs.vue";
import PriceChart from "./PriceChart.vue";
import RorChart from "./RorChart.vue";
import { Profit, Plan } from "@foxone/api/src/models/hfox";

@Component({
  components: {
    Tabs,
    PriceChart,
    RorChart
  }
})
class PlanCharts extends Vue {
  @Prop() plan!: Plan;

  typeIndex = 0;

  profits: Profit[] = [];

  get show() {
    return this.profits.length > 0;
  }

  get types() {
    return [
      {
        text: this.$t("common.ror"),
        value: "ROR",
        component: "ror-chart"
      },
      {
        text: this.$t("common.price.change"),
        value: "AVG",
        component: "price-chart"
      }
    ];
  }

  get component() {
    return this.types[this.typeIndex].component;
  }

  mounted() {
    this.initProfits();
  }

  async initProfits() {
    const profits = await this.$api.hfox.getPlanProfits(this.plan.id + "");
    const min = new Date().getTime() - 365 * 24 * 3600 * 1000;
    this.profits = profits.filter(p => {
      const date = new Date(p.date).getTime();
      return date > min;
    });
  }
}
export default PlanCharts;
